import React, { createContext, useContext, useEffect, useState } from "react";
import { translations } from "@/i18n/translations";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("tgs-lang") || "ht");
  const [theme, setTheme] = useState(() => localStorage.getItem("tgs-theme") || "dark");

  useEffect(() => {
    localStorage.setItem("tgs-lang", lang);
  }, [lang]);

  useEffect(() => {
    localStorage.setItem("tgs-theme", theme);
    const root = document.documentElement;
    if (theme === "dark") root.classList.add("dark");
    else root.classList.remove("dark");
  }, [theme]);

  const t = (key) => translations[lang]?.[key] || translations.en[key] || key;

  return (
    <LanguageContext.Provider value={{ lang, setLang, theme, setTheme, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLang = () => useContext(LanguageContext);
